import React, { Component } from 'react'

import { connect } from 'react-redux'
import Loading from './Loading'
import SyncProgressOverlay from './sync/SyncProgressOverlay'
import { isSyncProgressMode } from '../utils/syncPanelModel'

class LoadingOverlay extends Component {
  render() {
    // PG-063: durante Sincronizar/download o cartão vira o painel em modo progresso.
    // (Não há conflito com a limpeza local da PG-060: CleanupResumeGate troca as rotas, e
    // com elas o App e este overlay, pelo ResetFlowOverlay enquanto a sessão de limpeza roda.)
    if (this.props.progressMode) return <SyncProgressOverlay />
    return (
      <Loading
        open={this.props.loading}
        label={this.props.loadingLabel}
        isGlobalOverlay
      />
    )
  }
}

const mapStateToProps = (state) => ({
  loading: state.screen.loading,
  loadingLabel: state.screen.loadingLabel,
  progressMode: !!state.screen.loading && isSyncProgressMode(state.sync),
})

export default connect(mapStateToProps, null)(LoadingOverlay)
